import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'placeholder',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'admin.intellitryx.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'intellitryx',
};

export const isDevMode = firebaseConfig.apiKey === 'placeholder';

let app: FirebaseApp | null = null;
let auth: Auth | null = null;

if (!isDevMode) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
}

export { app, auth };
